import { LOADING_REFERENCES, RECEIVED_REFERENCES, RECEIVED_REFERENCES_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/pii/${pii}/references?token=${token}`,
  },
  fetch: createFetcher(LOADING_REFERENCES, RECEIVED_REFERENCES, RECEIVED_REFERENCES_FAILED),
};
